module.exports = __webpack_public_path__ + "static/media/final_copa.338dab9f.webp";